import { render, staticRenderFns } from "./InvoiceShow.vue?vue&type=template&id=2925553f&"
import script from "./InvoiceShow.vue?vue&type=script&lang=js&"
export * from "./InvoiceShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports